import { render, staticRenderFns } from "./SingleTransactionModal.vue?vue&type=template&id=a2fba4d0&"
import script from "./SingleTransactionModal.vue?vue&type=script&lang=js&"
export * from "./SingleTransactionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports